import React, { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import { Box, Grid, Stack, Tooltip } from "@mui/material";
import "../../FrontEnd/Gallery/Gallery.css";
import ImageListItemBar from '@mui/material/ImageListItemBar';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import FilePopup from 'components/Input/UploadFile/components/PopUp/FilePopup';

export interface IPropsGallery {
    arrGallery: any;
    sDate: any;
    sName: any;
    color?: string;
    sHeadDescription?: any;
}

const GalleryPreview = (props: IPropsGallery) => {
    const [arrGallery, setarrGallery] = useState([]);
    const [fileImage, setFileImage] = useState([]);
    const [IsopenPopUp, setIsopenPopUp] = useState<any>(false);

    useEffect(() => {
        if (props.arrGallery.length > 0) setarrGallery(props.arrGallery);
        arrGallery.sort((a, b) => a.nOrder - b.nOrder);
    }, [props]);

    const OpenPopUp = (ObjFileID) => {
        let arrNewPicture = [];
        let arrClickedPicture = arrGallery.find(f => f.nID === ObjFileID); //choose picture
        arrNewPicture.push(arrClickedPicture); //add choose picture to array
        let arrNoClickedPicture = arrGallery.filter(f => f.nID !== ObjFileID); //not choose picture
        let arrAllPicture = arrNewPicture.concat(arrNoClickedPicture); //combine 2 array

        setFileImage(arrAllPicture);
        setIsopenPopUp(true);
    };

    return (
        <React.Fragment>
            <Grid container justifyContent={"center"}>
                <Grid item container justifyContent={"center"} xs={12} md={12} >
                    <Typography variant="h3" fontWeight={500}>
                        {props.sDate}
                    </Typography>
                </Grid>
                <Grid item container justifyContent={"center"} xs={12} md={12} style={{ marginTop: 20 }} >
                    <Typography variant="h4" fontWeight={500}>
                        {props.sName}
                    </Typography>
                </Grid>
                {props.sHeadDescription !== null ? (
                    <Grid item container justifyContent={"center"} xs={12} md={12} style={{ marginTop: 20 }} >
                        <Typography variant="h5">
                            {props.sHeadDescription}
                        </Typography>
                    </Grid>
                ) : null}
                {(arrGallery).length > 0 ? (
                    <Grid container spacing={{ xs: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }} style={{ marginTop: 20 }}>
                        {(arrGallery).map((item, index) => {
                            return (
                                <Grid item xs={12} sm={4} md={4} key={index}>
                                    <Box className="box-Gallery">
                                        {item.sNameForDisplay == "" || item.sNameForDisplay == null || item.sNameFileDescription == null || item.sNameFileDescription == "" ?
                                            <img
                                                src={item.sFileLink}
                                                alt={""}
                                                style={{ width: "100%", height: "100%", minHeight: "auto", maxHeight: "37vw", objectFit: "cover", cursor: "pointer", }}
                                                onClick={() => OpenPopUp(item.nID)}
                                            />
                                            :
                                            <>
                                                <img
                                                    src={item.sFileLink}
                                                    alt={""}
                                                    style={{
                                                        width: '100%',
                                                        minHeight: "100%",
                                                        height: "100%",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => OpenPopUp(item.nID)}
                                                />
                                                <ImageListItemBar style={{
                                                    width: '100%',
                                                    height: '20%'
                                                }}
                                                    title={
                                                        <Stack
                                                            sx={{
                                                                b: {
                                                                    "@media": {
                                                                        maxWidth: "500px",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        cursor: "pointer",
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            {/* picture name */}
                                                            <Tooltip title={item.sNameForDisplay}>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: 16,
                                                                        fontWeight: "bolder",
                                                                        textTransform: "none",
                                                                    }}
                                                                    component="b"
                                                                >
                                                                    {item.sNameForDisplay}
                                                                </Typography>
                                                            </Tooltip>

                                                            {/* picture description */}
                                                            <Tooltip title={item.sNameFileDescription}>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: 16,
                                                                        fontWeight: "lighter",
                                                                        textTransform: "none",
                                                                    }}
                                                                    component="b"
                                                                >
                                                                    {item.sNameFileDescription}
                                                                </Typography>
                                                            </Tooltip>
                                                        </Stack>
                                                    }
                                                />
                                            </>
                                        }
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                ) :
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            m: "5em 5em 8em 5em"
                        }}
                    >
                        <Typography sx={{ fontSize: "24px", color: "#aeb4b7" }}>
                            ไม่พบข้อมูล
                        </Typography>
                    </Box>
                }
            </Grid>

            {fileImage.map((m, i) => (
                <FilePopup
                    file={m}
                    IsopenPopUp={IsopenPopUp}
                    ClosePopUp={() => { setIsopenPopUp(false) }}
                    sFile_ID={m.sFile_ID}
                    isGallery={true}
                    arrFile={fileImage}
                    id={fileImage}
                    setarrFile={setFileImage}
                    IsMultiple={true}
                    sPositionText="right"
                    cropRatio={16 / 9}
                    cropResize={true}
                    cropShape='retangle'
                    modeDisplay='gallery'
                    IsGalleryPage={true}
                />
            ))}

            {/* <FilePopup
                file={fileImage}
                IsopenPopUp={IsopenPopUp}
                ClosePopUp={() => { setIsopenPopUp(false) }}
                sFile_ID={fileImage}
                isGallery={true}
                arrFile={fileImage}
                id={fileImage}
                setarrFile={setFileImage}
                IsMultiple={true}
                sPositionText="right"
                cropRatio={16 / 9}
                cropResize={true}
                cropShape='retangle'
                modeDisplay='gallery'
            /> */}
        </React.Fragment>
    )
}

export default GalleryPreview;